import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commaSpace',
  standalone: true,
})
export class CommaSpacePipe implements PipeTransform {
  transform(value: string): string {
    if (!value || typeof value !== 'string') {
      return value || '';
    }

    return value.replaceAll(',', ', ').replaceAll('  ', ' ');
  }
}
